import { useCallback, useEffect, useRef } from 'react';

import { useApplicationState } from '@atlas/core';

import { POSTHOG_EVENTS } from 'common/constants';

import usePostHog from './usePostHog';

const usePixPopupPostHog = () => {
  const postHog = usePostHog();
  const { account } = useApplicationState() || {};
  const shownTimestampRef = useRef(Date.now());

  const clientId = account?.id ?? null;

  const interactionsRef = useRef({
    copy_code_clicked: null,
    generate_new_code_clicked: null,
    manual_close_timestamp: null,
    show_qr_code: null,
  });

  const buildPayload = useCallback(
    patch => {
      Object.assign(interactionsRef.current, patch);

      return {
        ...interactionsRef.current,
        client_id: clientId,
        shown_timestamp: shownTimestampRef.current,
      };
    },
    [clientId],
  );

  const buildPayloadRef = useRef(buildPayload);
  buildPayloadRef.current = buildPayload;

  const postHogRef = useRef(postHog);
  postHogRef.current = postHog;

  useEffect(() => {
    postHogRef.current.concat(POSTHOG_EVENTS.PIX_POP_UP_SHOWN, buildPayloadRef.current({}));
  }, []);

  const handleShowQr = useCallback(() => {
    postHog.concat(POSTHOG_EVENTS.PIX_POP_UP_SHOWN, buildPayload({ show_qr_code: Date.now() }));
  }, [buildPayload, postHog]);

  const handleCopyCode = useCallback(() => {
    postHog.send(POSTHOG_EVENTS.PIX_POP_UP_SHOWN, buildPayload({ copy_code_clicked: Date.now() }));
  }, [buildPayload, postHog]);

  const handleGenerateNewCode = useCallback(() => {
    postHog.send(
      POSTHOG_EVENTS.PIX_POP_UP_SHOWN,
      buildPayload({ generate_new_code_clicked: Date.now() }),
    );
  }, [buildPayload, postHog]);

  const handleManualClose = useCallback(() => {
    postHog.send(
      POSTHOG_EVENTS.PIX_POP_UP_SHOWN,
      buildPayload({ manual_close_timestamp: Date.now() }),
    );
  }, [buildPayload, postHog]);

  return { handleCopyCode, handleGenerateNewCode, handleManualClose, handleShowQr };
};

export default usePixPopupPostHog;
